/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Title_Project_ExportInputs */



/**
* | output |
* | --- |
* | "Project Export" |
*
* @param {Ateliere_Connect_Title_Project_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_title_project_export = /** @type {((inputs?: Ateliere_Connect_Title_Project_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Title_Project_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt-Export")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación de proyectos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目出口")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトのエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परियोजना निर्यात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação de Projetos")
	return /** @type {LocalizedString} */ ("Project Export")
});